import type { ComponentProps } from 'react';

// Native select is a deliberate form compatibility adapter. Keeping the
// original DOM placement and size attribute preserves mobile pickers, existing
// form.elements reads, option values and CSS layout selectors.
export function NativeSelect(props: ComponentProps<'select'>) {
  return <select data-slot="native-select" {...props} />;
}
